/* eslint-disable no-undef */

export const gtmEventTrigger = (value) => {
  if (JSON.parse(process.env.PRODUCTION)) {
    dataLayer.push({ event: value });
  }
};

export const gtmCustomTrigger = (customEvent, value) => {
  if (JSON.parse(process.env.PRODUCTION)) {
    dataLayer.push(JSON.parse(`{ "${customEvent}": "${value}" }`));
  }
};

export const generateReviewSchema = (detail) => {
  if (!detail) {
    return null;
  }

  const reviewSchema = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Intercâmbio - Fluencypass',
    image:
      'https://res.cloudinary.com/intercambiodireto-com/f_auto,c_limit,w_384,q_50/fluency_pass_logotipo.png',
    description:
      'A maior plataforma online de intercâmbio. Compare agora mesmo centenas de países, cidades e escolas no exterior, com até 40% off, sem taxa de agência e até 12x para pagar. Suporte e assessoria grátis.',
    brand: {
      '@type': 'Brand',
      name: 'Fluencypass',
    },
    gtin8: 'BR',
    currenciesAccepted: 'BRL',
    paymentAccepted: 'Crédito, Débito, Dinheiro, Boleto e Transferência',
    areaServed: 'BR',
    award:
      'Compare orçamentos para o seu intercâmbio com até 40% off, sem taxa de agência, com suporte e assessoria grátis.',
    sku: 'intercambio',
    aggregateRating: {
      '@type': 'AggregateRating',
      bestRating: '5',
      worstRating: '1',
      ratingValue: '3',
      ratingCount: '5',
    },
    review: {
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: 'Fluencypass',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Google',
      },
    },
    itemReviewed: {
      '@type': 'School',
      name: detail?.fantasyName,
    },
  };

  if (detail?.rating?.average > 0) {
    reviewSchema.aggregateRating.ratingValue = Math.round(
      detail?.rating?.average
    ).toString();
    reviewSchema.aggregateRating.ratingCount =
      detail?.comments?.length.toString();
  }

  if (detail?.comments > 0) {
    reviewSchema.review.reviewBody = detail?.comments[0].commentText;
  }

  return JSON.stringify(reviewSchema);
};
